import { createFileRoute } from '@tanstack/react-router';
import CompletionPage from '@/features/completion';

export const Route = createFileRoute('/_protected/completion/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <CompletionPage />;
}
